var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiselectUnlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160544",
    "data-name": "Group 160544",
    transform: "translate(-448 -1200)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1920",
    "data-name": "Rectangle 1920",
    width: 16,
    height: 16,
    transform: "translate(448 1200)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lock-open-outline",
    transform: "translate(356.638 1171.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M179.939,33.7a1.992,1.992,0,0,0-3.939,0v2.037",
    transform: "translate(-78.768 -0.534)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1923",
    "data-name": "Rectangle 1923",
    width: 8,
    height: 6,
    rx: 2,
    transform: "translate(95.362 35.478)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiselectUnlockIcon);
export default __webpack_public_path__ + "static/media/MultiselectUnlock-icon.dd5e3590225b70984078ecb5a7e5693f.svg";
export { ForwardRef as ReactComponent };